var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChart = function SvgChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.5 17.5V5c0-.777 0-1.165-.127-1.47a1.67 1.67 0 0 0-.902-.903C11.165 2.5 10.777 2.5 10 2.5s-1.165 0-1.47.127a1.67 1.67 0 0 0-.903.902C7.5 3.835 7.5 4.223 7.5 5v12.5m5 0h-5m5 0V6.667h1.667c1.571 0 2.356 0 2.845.488.488.488.488 1.273.488 2.845v4.167c0 1.571 0 2.356-.488 2.845-.489.488-1.274.488-2.845.488zm-5 0H5.833c-1.571 0-2.356 0-2.845-.488-.488-.489-.488-1.274-.488-2.845s0-2.357.488-2.845c.489-.489 1.274-.489 2.845-.489H7.5z"
  })));
};
export default SvgChart;